import { UploadFilesEvent } from '@alfresco/adf-content-services';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WkFileUploadEventService {
  private readonly upload$ = new Subject<UploadFilesEvent>();

  public triggerUploadFilesEvent(event: UploadFilesEvent): void {
    this.upload$.next(event);
  }

  public onFilesUploadEvent(): Observable<UploadFilesEvent> {
    return this.upload$.asObservable();
  }
}
